import { put, takeEvery } from "redux-saga/effects";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import { push } from "connected-react-router";
var btoa = require("Base64").btoa;

function* fetchmyteam(value) {
  console.log(value);
  const token = localStorage.getItem("token");

  let page = (value.value && value.value.page) || 1;
  let search = (value.value && value.value.search) || "";
  let filter = (value.value && value.value.filter) || "";
  let secfilter = (value.value && value.value.secfilter) || "";
  let user = JSON.parse(localStorage.getItem("user"));
  let id = user.orgId;
  let runnerrole = "runnerAccount,runnerTrip,runnerSupport";
  let shipperrole = "shprAccount,shprSupport";
  let url = "";
  let filterParam = "";
  if (filter) {
    filterParam = `&role=${filter}`;
  }

  if (user.role === "runner") {
    url = `&role=${runnerrole}`;
  } else {
    url = `&role=${shipperrole}`;
  }


  let secfilterParam = "";
  if (secfilter) {
    secfilterParam = `&status=${secfilter}`;
  }

  try {
    const res = yield fetch(
      `${appConfig.ip}/users?orgId=${id}&ser=${search}&limit=10&page=${page}${url}${filterParam}${secfilterParam}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.FETCH_MYTEAM_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.FETCH_MYTEAM_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* addTeams(value) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));


  const data = {
    name: value.value.fName,
    lName: value.value.lName,
    role: value.value.role,
    callingCode: user.callingCode,
    mobileNo: value.value.mobileNo,
    email: value.value.email,
    password: value.value.password,
    orgId: user.orgId,
    orgName: user.orgName,
    curncyCode: user.curncyCode,
    country: user.country,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/users/createuser`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();

      yield put({
        type: actionTypes.ADD_TEAM_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success(`You have succesfully added a team member in ${resJSON.role} role`, {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: actionTypes.FETCH_MYTEAM_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.ADD_TEAM_FAIL_ACTION,
        error: err,
      });
    }
  }
}

function* editMyteam(value) {
  let id = value.id;

  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  // let data = value.params;
  const data = {
    name: value.params.fName,
    lName: value.params.lName,
    role: value.params.role,
    callingCode: user.callingCode,
    mobileNo: value.params.mobileNo,
    orgId: user.orgId,
    orgName: user.orgName,
    curncyCode: user.curncyCode,
    country: user.country,
  };

  try {
    const res = yield fetch(`${appConfig.ip}/users/updateUser/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
  
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();
      yield put({ type: actionTypes.FETCH_MYTEAM_ACTION });
      yield put({
        type: actionTypes.EDIT_MYTEAM_SUCCESS_ACTION,
        payload: resJSON,
      });
      yield toast.success("Team updated successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.EDIT_MYTEAM_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* deleteteam(params) {
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
 
  let id = params.data.id;
  let data = {
    status: "deleted",
  };

  try {
    const res = yield fetch(`${appConfig.ip}/users/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ isActive: false, ...data }),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      yield put({ type: actionTypes.FETCH_MYTEAM_ACTION });
      yield put({
        type: actionTypes.DELETE_MYTEAM_SUCCESS_ACTION,
        payload: id,
      });
      yield toast.success("Team deleted successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.DELETE_MYTEAM_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* statuschangeTeam(params) {
  let id = params.data.id;

  let data =
    params.data.status === "active"
      ? { status: "suspended" }
      : { status: "active" };

  try {
    const token = localStorage.getItem("token");
    const res = yield fetch(`${appConfig.ip}/users/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {
        throw Object.assign(res, errJSON);
      }
    } else {
      const resJSON = yield res.json();
      yield toast.success(" Change status successfully", {
        autoClose: 3000,
        className:"toastClass"
      });
      yield put({
        type: actionTypes.STATUSCHANGE_MYTEAM_SUCCESS_ACTION,
      });
      yield put({
        type: actionTypes.FETCH_MYTEAM_ACTION,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.STATUSCHANGE_MYTEAM_FAIL_ACTION,
        error: err,
      });
    }
  }
}

export function* MyTeamsActionWatcher() {
  yield takeEvery(actionTypes.FETCH_MYTEAM_ACTION, fetchmyteam);
  yield takeEvery(actionTypes.ADD_TEAM_INIT_ACTION, addTeams);
  yield takeEvery(actionTypes.EDIT_MYTEAM_INIT_ACTION, editMyteam);
  yield takeEvery(actionTypes.DELETE_MYTEAM_INIT_ACTION, deleteteam);
  yield takeEvery(
    actionTypes.STATUSCHANGE_MYTEAM_INIT_ACTION,
    statuschangeTeam
  );
}
